// 数据统计
// import api from '../../api'

const state = {
  accountGroup: [
    {
      value: '',
      label: '全部'
    },
    {
      value: '10000',
      label: '咪咕视频'
    },
    {
      value: '10002',
      label: '咪咕阅读'
    },
    {
      value: '10003',
      label: '销售拓展单元'
    },
    {
      value: '10015',
      label: '圈粉俱乐部'
    },
    {
      value: '10001',
      label: '咪咕音乐'
    },
    {
      value: '10005',
      label: '咪咕圈圈'
    },
    {
      value: '10006',
      label: '咪咕快游'
    },
    {
      value: '10007',
      label: '营销单元'
    },
    {
      value: '10016',
      label: '咪咕善跑'
    },
    {
      value: '10017',
      label: '广东咪咕视频运营组'
    },
    {
      value: '10018',
      label: '河南咪咕视频运营组'
    },
    {
      value: '10019',
      label: '全媒体中心（南京）'
    },
    {
      value: '10020',
      label: '厦门大区湖南移动'
    },
    {
      value: '10021',
      label: '山东咪咕视频运营组'
    },
    {
      value: '10022',
      label: '湖南咪咕视频运营组'
    },
    {
      value: '10023',
      label: '江苏咪咕视频运营组'
    },
    {
      value: '10024',
      label: '天津移动'
    },
    {
      value: '10025',
      label: '青海移动'
    },
    {
      value: '10026',
      label: '云南移动'
    },
    {
      value: '10027',
      label: '海南移动'
    },
    {
      value: '10028',
      label: '黑龙江移动'
    },
    {
      value: '10029',
      label: '湖南移动'
    },
    {
      value: '10030',
      label: '广西移动'
    },
    {
      value: '10031',
      label: '陕西移动'
    },
    {
      value: '10032',
      label: '北京移动'
    },
    {
      value: '10033',
      label: '135项目组'
    },
    {
      value: '10035',
      label: '    咪咕影院'
    },
    {
      value: '10036',
      label: '咪咕互娱游戏发行'
    },
    {
      value: '10037',
      label: '一级电渠'
    },
    {
      value: '10038',
      label: '快游大屏'
    },
    {
      value: '10039',
      label: '咪咕视频大屏业务组'
    },
    {
      value: '10040',
      label: '用户运营 - 融合业务'
    },
    {
      value: '10041',
      label: '用户运营 - 音乐业务'
    },
    {
      value: '10042',
      label: '用户运营 - 视频业务2'
    },
    {
      value: '10043',
      label: '重庆移动'
    },
    {
      value: '10044',
      label: '新疆移动'
    },
    {
      value: '10045',
      lable: '广东移动'
    },
    {
      value: '10046',
      label: '山西移动'
    },
    {
      value: '10048',
      label: '安徽移动'
    },
    {
      value: '10049',
      label: '福建移动'
    },
    {
      value: '10050',
      label: '甘肃移动'
    },
    {
      value: '10051',
      label: '贵州移动'
    },
    {
      value: '10052',
      label: '河北移动'
    },
    {
      value: '10053',
      label: '河南移动'
    },
    {
      value: '10054',
      label: '湖北移动'
    },
    {
      value: '10055',
      label: '江苏移动'
    },
    {
      value: '10056',
      label: '江西移动'
    },
    {
      value: '10057',
      label: '辽宁移动'
    },
    {
      value: '10058',
      label: '内蒙古移动'
    },
    {
      value: '10059',
      label: '宁夏移动'
    },
    {
      value: '10060',
      label: '山东移动'
    },
    {
      value: '10061',
      label: '上海移动'
    },
    {
      value: '10062',
      label: '四川移动'
    },
    {
      value: '10063',
      label: '西藏移动'
    },
    {
      value: '10064',
      label: '浙江移动'
    },
    {
      value: '10065',
      label: 'TSG'
    },
    {
      value: '10066',
      label: '平台运营组'
    },
    {
      value: '10067',
      label: '平台演示组'
    },
    {
      value: '10068',
      label: '咪咕音乐视频彩铃'
    },
    {
      value: '10069',
      label: 'ISG'
    },
    {
      value: '10070',
      label: '用户运营-视频业务1'
    },
    {
      value: '10071',
      label: '营销单元-素材运营组'
    },
    {
      value: '10072',
      label: '咪咕电竞运营中心'
    },
    {
      value: '10073',
      label: '移动云VR'
    },
    {
      value: '10074',
      label: '一级IOP集中运营'
    },
    {
      value: '10075',
      label: '咪咕互娱政企'
    },
    {
      value: '10076',
      label: '咪咕数媒营销策划'
    },
    {
      value: '10077',
      label: '即用即评-咪咕快游'
    }
  ],

  pageStatus: [
    {
      value: '3',
      label: '已发布'
    },
    {
      value: '4',
      label: '已下线'
    }
  ],
  templateCenter: [
    {
      value: '1',
      label: '我的模板'
    },
    {
      value: '2',
      label: '模板中心'
    }
  ],
  fileType: [
    {
      value: '1',
      label: '页面数据'
    },
    {
      value: '2',
      label: '我的模板数据'
    },
    {
      value: '3',
      label: '模板中心数据'
    }
  ]
}

const getters = {
  accountGroup: state => state.accountGroup,
  pageStatus: state => state.pageStatus,
  templateCenter: state => state.templateCenter,
  fileType: state => state.fileType
}

const actions = {

}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
